import { createAction } from '@wix/communities-blog-client-common';

export const SET_SEO_PATTERNS = 'seo-patterns/SET';
export const setSEOPatterns = createAction(SET_SEO_PATTERNS);
